import { callable } from '../callable';
import type { AssistantChatSessionProps, AssistantChatSummaryProps } from '@dosfilos/domain';
import type { AssistantContextHint } from '../assistant-context';

// ─── Cliente del asistente ───────────────────────────────────────────────────
// TRANSVERSAL: no vive en el cliente de la red porque el asistente no es de la
// red. Lo que el cliente manda es una PISTA de contexto; la audiencia y el
// corpus los decide el servidor desde el rol.

function call<Req, Res>(name: string) {
  const fn = callable<Req, Res>(name);
  return async (data: Req): Promise<Res> => (await fn(data)).data;
}

export const assistantApi = {
  /** Manda un mensaje y devuelve la conversación completa. */
  send: call<
    {
      tenantId: string;
      message: string;
      /** Ausente = conversación sobre el proceso. */
      contextHint?: AssistantContextHint;
      sessionId?: string;
      /** DESEMPATE del idioma: la respuesta sigue el idioma de la PREGUNTA, y
       *  esto sólo decide cuando el mensaje es demasiado corto para saberlo. */
      uiLocale?: 'es' | 'en';
    },
    AssistantChatSessionProps
  >('assistantMessage'),

  /** Las conversaciones de esta persona en ESTE contexto. */
  list: call<
    { tenantId: string; contextHint?: AssistantContextHint },
    { sessions: AssistantChatSessionProps[] }
  >('assistantListChats'),

  /** El historial completo, de todos los contextos. Alimenta el selector para
   *  volver a una conversación anterior. */
  /** RESÚMENES, no conversaciones enteras: la lista muestra tres campos y traer
   *  los turnos completos de treinta conversaciones hacía lento justo lo que
   *  más se usa. */
  history: call<{ tenantId: string; limit?: number }, { sessions: AssistantChatSummaryProps[] }>(
    'assistantHistory',
  ),

  /** La conversación completa, al elegirla del historial. */
  open: call<{ tenantId: string; sessionId: string }, AssistantChatSessionProps>(
    'assistantOpenChat',
  ),

  /** Elimina una conversación. Borra de verdad: no hay manera de recuperarla. */
  remove: call<{ tenantId: string; sessionId: string }, { ok: true }>('assistantDeleteChat'),
};
